import request from '@/utils/request'
import qs from 'qs'

// 账号登录
const user_login = (data) => {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 登录注销
const user_logout = () => {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 快捷登录（手机号）
const user_quickLogin = (data) => {
  return request({
    url: '/user/quickLogin',
    method: 'post',
    data
  })
}

// 刷新登录凭证
const user_refresh = (data, headers) => {
  return request({
    url: '/user/refresh',
    method: 'post',
    data: qs.stringify(data),
    headers
  })
}

// 凭证授权
const user_token_auth = (data, headers) => {
  return request({
    url: '/user/token/auth',
    method: 'post',
    data,
    headers
  })
}

export {
  user_token_auth,
  user_login,
  user_logout,
  user_quickLogin,
  user_refresh
}
